<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-blog></app-breadcrumb-blog>
    <app-blog-section></app-blog-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
